import { ProgressReview } from "../../Models/ProgressReview";
import { ChatManager } from "./ChatManager";
import { CustomMessageOrderMetaDetails, GGCustomMessageDetails, GGCustomMessageType, OrderCompletedCardDetails, OrderPaymentCardDetails, OrderProposalActionTakenCardDetails, OrderProposalActionType, OrderSubmittedBySellerCardDetails, ProgressReviewCardDetails, RevisionRequestCardDetails } from "../../components/PageComponents/ChatComponents/GGCustomMessageTypes";

class CustomMessageDeliveryHandler {

    private channelId: string

    constructor(channelId: string) {
        this.channelId = channelId
    }

    public sendOrderPaymentCardCustomMessage = async (actionCardId: string) => {
        const orderPaymentCard: OrderPaymentCardDetails = {
            type: GGCustomMessageType.orderPaymentCard,
            actionCardId: actionCardId
        }
        await this.sendMessageToChannel(orderPaymentCard, "Order Proposal sent.");
    }

    public sendOrderProposalActionTakenCustomMessage = async (actionType: OrderProposalActionType, orderMetaData: CustomMessageOrderMetaDetails) => {
        const customMessageData: OrderProposalActionTakenCardDetails = {
            type: GGCustomMessageType.orderProposalActionTakenCard,
            orderAction: actionType,
            orderMetaData: orderMetaData
        }
        let messageText = "Order Proposal Action Taken."
        switch (actionType) {
            case OrderProposalActionType.accepted:
                messageText = "Order proposal accepted by client"
                break;
            case OrderProposalActionType.rejected_by_buyer:
                messageText = "Order proposal rejected by client"
                break;
            case OrderProposalActionType.revoked_by_seller:
                messageText = "Order proposal revoked by freelancer"
                break;
        }
        await this.sendMessageToChannel(customMessageData, messageText);
    }

    public sendRevisionRequestCustomMessage = async (revisionId: string) => {
        const customMessageData: RevisionRequestCardDetails = {
            type: GGCustomMessageType.revisionRequestCard,
            revisionId: revisionId
        }

        await this.sendMessageToChannel(customMessageData, "Revision requested for order.");
    }

    public sendProgressReviewCustomMessage = async (progressReview: ProgressReview) => {
        const customMessageData: ProgressReviewCardDetails = {
            type: GGCustomMessageType.progressReviewCard,
            progressReviewId: progressReview.id,
        }

        await this.sendMessageToChannel(customMessageData, "Progress till now shared.");
    }

    public sendOrderSubmittedBySellerCustomMessage = async (orderId: string, orderMetaData: CustomMessageOrderMetaDetails) => {
        const customMessageData: OrderSubmittedBySellerCardDetails = {
            type: GGCustomMessageType.orderSubmittedBySellerCard,
            orderId: orderId,
            orderMetaData
        }

        await this.sendMessageToChannel(customMessageData, "Order delivery has been made by the freelancer.");
    }

    public sendOrderCompletedustomMessage = async (orderId: string, orderCompletionTimeStamp: number, orderMetaData: CustomMessageOrderMetaDetails) => {
        const customMessageData: OrderCompletedCardDetails = {
            type: GGCustomMessageType.orderCompletedCard,
            orderId: orderId,
            orderCompletionTimeStamp,
            orderMetaData
        }

        await this.sendMessageToChannel(customMessageData, "Order has been successfully completed.");
    }

    private sendMessageToChannel = async (customMessage: GGCustomMessageDetails, message: string = "Custom Message") => {
        const ggCustomMessageData = { ggCustomMessageData: customMessage };
        await ChatManager.shared.sendMessageToChannel(this.channelId, ggCustomMessageData, message)
    }
}

export default CustomMessageDeliveryHandler;